import { PdfFileIcon } from "@images/svgIcons/medias/pdfFileIcon"
import { word } from "@modules/core/utils/i18n"
import { MediaItemFormikType } from "@modules/sessionBlock/media/mediaFormikTypes"
import { HUText } from "@modules/ui/components/huText"
import { ComponentProps } from "react"
import { useTheme } from "styled-components"

type MediaExistingBlockPdfProps = {
  media: MediaItemFormikType
} & ComponentProps<"div">

export function MediaExistingBlockPdf({ media, ...props }: MediaExistingBlockPdfProps) {
  const theme = useTheme()

  return (
    <div className="flex flex-row align-items-center justify-content-start gap-3 overflow-hidden" {...props}>
      <div style={{ width: 190, height: 90 }} className="overflow-hidden flex flex-row justify-content-center">
        {media.file || media.url ? (
          <PdfFileIcon color={theme.neutralColor900} />
        ) : (
          <HUText fontStyle="BM" style={{ overflowWrap: "break-word" }}>
            {word("sessionForm.blocks.add_media.missing_error")}
          </HUText>
        )}
      </div>
      <HUText fontStyle="BM" className="text-overflow-ellipsis overflow-hidden">
        {media.filename}
      </HUText>
    </div>
  )
}
